import {Api} from '../../api/api'
import HTTP from './http'

export function scrollChange() {
    window.onscroll = function (callback) {
        // 变量scrollTop是滚动条滚动时，距离顶部的距离
        let scrillTop = document.documentElement.scrollTop || document.body.scrollTop
        //变量windowHeight是可视区的高度
        var windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
        //变量scrollHeight是滚动条的总高度
        var scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
        callback({
            scrollTop: scrillTop
        })
        if (scrillTop + windowHeight == scrollHeight) {
            //到了这个就可以进行业务逻辑加载后台数据了
            console.log("到了底部");
        }
    }
}

export function wxShare(title, desc, imgUrl, activityId) {
    window.wx.ready(() => {
        window.wx.onMenuShareAppMessage({
            title: title || null, // 分享标题
            desc: desc || null, // 分享描述
            link: window.location.href, // 分享链接；在微信上分享时，该链接的域名必须与企业某个应用的可信域名一致
            imgUrl: imgUrl || null, // 分享图标
            success: function () {
                // 用户确认分享后执行的回调函数
                console.log('分享承成功 id：' + activityId)
                if (activityId) {
                    let userId = localStorage.getItem('userId-school')
                    let params = {
                        activityid: activityId,
                        fromid: userId
                    }
                    HTTP.post(Api.forwardSave, params).then(res => {
                        console.log(res);
                    })
                }
            },
            cancel: function () {
                // 用户取消分享后执行的回调函数
            }
        })
    })
}
